const data = {
  status: "success",
  items: [
    {
      id: 1,
      title: "AMERICANA",
      price: 4690,
      description: "Jamón, Carne, Salchicha, Pepperoni",
      image: "https://i.imgur.com/0dIk4bV.png",
      category: "pizza",
      cantidad: 1,
    },
    {
      id: 2,
      title: "BBQ CHICKEN",
      price: 7750,
      description: "Salsa BBQ, Pollo, Cebolla",
      image: "https://i.imgur.com/qTTQ8mB.png",
      category: "pizza",
      cantidad: 1
    },
    {
      id: 3,
      title: "CAMPESINA",
      price: 6050,
      description: "Pollo, Pimiento, Champiñón",
      image: "https://i.imgur.com/GT0RFGP.png",
      category: "pizza",
      cantidad: 1
    },
    {
      id: 4,
      title: "HAWAIANA",
      price: 7750,
      description: "Pollo, Jamón, Piña",
      image: "https://i.imgur.com/T3r2dJ2.png",
      category: "pizza",
      cantidad: 1
    },
    {
      id: 5,
      title: "MECHADA BBQ",
      price: 6405,
      description: "Carne Mechada, Tomate, Cebolla",
      image: "https://i.imgur.com/T0t7syS.png",
      category: "pizza",
      cantidad: 1
    },
    {
      id: 6,
      title: "VEGAN QUEEN",
      price: 5670,
      description: "Champiñón, Pimiento, Cebolla, Choclo y Tomate",
      image: "https://i.imgur.com/OFNZECe.png",
      category: "pizza",
      cantidad: 1
    },
    {
      id: 7,
      title: "Coca Cola",
      price: 1690,
      description: "600 ml",
      image: "https://i.imgur.com/GGDGMVI.png",
      category: "Refresco",
      cantidad: 1
    },
    {
      id: 8,
      title: "Fanta",
      price: 1690,
      description: "600 ml",
      image: "https://i.imgur.com/wzR8Awn.png",
      category: "Refresco",
      cantidad: 1
    },
    {
      id: 9,
      title: "Jugo Watts Durazno",
      price: 1200,
      description: "500 ml",
      image: "https://i.imgur.com/SqKP3KA.png",
      category: "Refresco",
      cantidad: 1
    },
    {
      id: 10,
      title: "Jugo Valle de Piña",
      price: 1200,
      description: "500 ml",
      image: "https://i.imgur.com/K2S4Ilf.png",
      category: "Refresco",
      cantidad: 1
    },
    {
      id: 11,
      title: "Canchantun con Gas",
      price: 1000,
      description: "600 ml",
      image: "https://i.imgur.com/5lsWwYd.png",
      category: "Refresco",
      cantidad: 1
    },
    {
      id: 12,
      title: "Canchantun sin Gas",
      price: 1000,
      description: "600 ml",
      image: "https://i.imgur.com/dMS36DJ.png",
      category: "Refresco",
      cantidad: 1
    },

    {
      id: 13,
      title: "Salsa BBQ",
      price: 600,
      description: "puré de jitomate,salsa picante, azúcar, cebolla",
      image: "https://i.imgur.com/qdhBUQ1.png",
      category: "Salsa",
      cantidad: 1
    },
    {
      id: 14,
      title: "Salsa Garlic",
      price: 600,
      description: "Salsa de Soja,Ketchup,Caldo Vegetal",
      image: "https://i.imgur.com/f2kBprP.png",
      category: "Salsa",
      cantidad: 1
    },
    {
      id: 15,
      title: "Salsa Picante",
      price: 600,
      description: "Tomate,cebolla,ajo,sal",
      image: "https://i.imgur.com/2VMxLSA.png",
      category: "Salsa",
      cantidad: 1
    },
    {
      id: 16,
      title: "Salsa Tomate",
      price: 600,
      description: "Tomate,azucar",
      image: "https://i.imgur.com/o6zPNEN.png",
      category: "Salsa",
      cantidad: 1
    },
    {
      id: 17,
      title: "PERSONALIZADA",
      price: 15000,
      description: "Personalizada",
      image: "https://i.imgur.com/0dIk4bV.png",
      category: "Personalizada",
      cantidad: 1
    },
  ],
  especial: [],
  locales: [
    {
      id: 18,
      nombre: "Local maipú",
      ubicacion: ["Santiago", "Maipú", "Del rey", "2038"],
      imagen: "",
    },
  ],

};

export default data;